import { render, staticRenderFns } from "./AdminDashBoardIndex.vue?vue&type=template&id=214526ad&"
import script from "./AdminDashBoardIndex.vue?vue&type=script&lang=js&"
export * from "./AdminDashBoardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports